import { put, takeLatest, all } from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import productBundleServices from '@Services/inventory/productBundleServices';
import ProductBundleActions, { productBundleActionTypes } from '@Actions/inventory/productBundleActions';

/**
 * @param action
 */
function* _getProductBundle(action) {
  try {
    yield put(ProductBundleActions.getProductBundleLoading(true));
    const {
      productSkuId, searchKeyword, tenantDepartmentId, viewType,
    } = action;
    const productBundles = yield productBundleServices.getProductBundle(productSkuId, searchKeyword, tenantDepartmentId, viewType);
    yield put(ProductBundleActions.getProductBundleSuccess(productBundles));
    if (action.callback) {
      action.callback(productBundles);
    }
    yield put(ProductBundleActions.getProductBundleLoading(false));
  } catch (error) {
    yield put(ProductBundleActions.getProductBundleLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productBundleActionTypes.GET_PRODUCT_BUNDLE.ERROR, error));
  }
}

/**
 *
 */
function* getProductBundle() {
  yield takeLatest(productBundleActionTypes.GET_PRODUCT_BUNDLE.REQUEST, _getProductBundle);
}
/**
 * @param action
 */
function* _createProductBundle(action) {
  try {
    yield put(ProductBundleActions.createProductBundleLoading(true));
    const productBundle = yield productBundleServices.createProductBundle(action.payload);
    if (productBundle.success) {
      yield put(TrackerActions.trackAction(productBundleActionTypes.CREATE_PRODUCT_BUNDLE.SUCCESS, productBundle.data));
      notification.open({
        type: 'success',
        message: 'Product Bundle successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(ProductBundleActions.createProductBundleLoading(false));
      if (action.callback) {
        action.callback(productBundle);
      }
    } else {
      notification.open({
        type: 'error',
        message: productBundle?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ProductBundleActions.createProductBundleLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productBundleActionTypes.CREATE_PRODUCT_BUNDLE.ERROR, error));
    yield put(ProductBundleActions.createProductBundleLoading(false));
  }
}

/**
 *
 */
function* createProductBundle() {
  yield takeLatest(productBundleActionTypes.CREATE_PRODUCT_BUNDLE.REQUEST, _createProductBundle);
}

/**
 *
 * @param {*} action
 */
function* _updateProductBundle(action) {
  try {
    yield put(ProductBundleActions.updateProductBundleLoading(true));
    const productBundle = yield productBundleServices.updateProductBundle(action.payload);
    if (productBundle.success) {
      yield put(TrackerActions.trackAction(productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.SUCCESS, productBundle.data));
      notification.open({
        type: 'success',
        message: 'Product Bundle updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(ProductBundleActions.updateProductBundleLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: productBundle.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ProductBundleActions.updateProductBundleLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.ERROR, error));
    yield put(ProductBundleActions.updateProductBundleLoading(false));
  }
}

/**
 *
 */
function* updateProductBundle() {
  yield takeLatest(productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.REQUEST, _updateProductBundle);
}

/**
 * @param action
 */
function* _getProductBundleById(action) {
  try {
    yield put(ProductBundleActions.getProductBundleByIdLoading(true));
    const {
      orgId, productBundleType, productBundleId, callback,
    } = action;
    const selectedProductBundle = yield productBundleServices.getProductBundleById(orgId, productBundleType, productBundleId);
    yield put(ProductBundleActions.getProductBundleByIdSuccess(selectedProductBundle));
    if (callback) {
      action.callback(selectedProductBundle);
    }
    yield put(ProductBundleActions.getProductBundleByIdLoading(false));
  } catch (error) {
    yield put(ProductBundleActions.getProductBundleByIdLoading(false));
    yield put(TrackerActions.trackAction(productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getProductBundleById() {
  yield takeLatest(productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.REQUEST, _getProductBundleById);
}

/**
 *
 */
export default function* productBundleSaga() {
  yield all([
    getProductBundle(), createProductBundle(), updateProductBundle(), getProductBundleById(),
  ]);
}
